// Shared component for resource detail pages.
// Data is fetched per-page via getStaticPaths + getStaticProps.
import ResourceDetail from "~/components/templates/resource/detail";
import ContentContext from "~/context/content";
import Error from "~/pages/_error";

const PostDetailPage = ({ data, error, type }) => {
    if (!data || error) return <Error />;

    return (
        <ContentContext layout="detail" type={type} data={data}>
            <ResourceDetail resource={data} type={type} />
        </ContentContext>
    );
};

export default PostDetailPage;
